import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo } from 'react';
import { uniq } from 'lodash';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import MobileModal from 'components/consumer/MobileModal';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomerQuote from 'components/consumer/CustomerQuote';
import IconSimpleArrowLeft from 'components/icons/iconSimpleArrowLeft';
import CustomerNameWithEmoji from 'components/consumer/CustomerNameWithEmoji';
import getShortCustomerName from 'commons/getShortCustomerName';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import useStaticProductCardData from 'hooks/useStaticProductCardData';
import ProductCardStatic from '../ProductCardStatic';
const GridWithSidebarPhotoModal = t0 => {
  const $ = _c(37);
  const {
    toggleModal,
    photosList,
    loadingMore,
    loadMore,
    photo
  } = t0;
  const {
    isMobile,
    isDesktop,
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? "4800px" : "6200px";
  let t1;
  bb0: {
    if (!!photosList && photosList.length) {
      let t2;
      if ($[0] !== photosList) {
        t2 = uniq(photosList.flatMap(_temp2));
        $[0] = photosList;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = [];
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const productIds = t1;
  let t2;
  if ($[3] !== productIds) {
    t2 = {
      productIds
    };
    $[3] = productIds;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    products: staticProductData
  } = useStaticProductCardData(t2);
  let t3;
  let t4;
  if ($[5] !== photo) {
    t3 = () => {
      setTimeout(() => {
        const photoId = !!photo && photo.photo_id;
        if (photoId) {
          const photoContainer = document.getElementById(`grid-with-sidebar-photo-modal__image-container-${photoId}`);
          if (photoContainer) {
            photoContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest"
            });
          }
        }
      }, 200);
    };
    t4 = [photo];
    $[5] = photo;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== isMobile || $[9] !== toggleModal) {
    t5 = !isMobile && <div className="fixed w-full p-0 bg-white flex items-stretch justify-between z-[1006] flex-wrap md:px-[3.333vw] md:py-0 md:h-[68px] md:[border-bottom:1px_solid_#e5e5e5]"><div className="flex content-start items-stretch flex-[1_1] px-[3.333vw] py-4 md:p-0 bg-white"><button type="button" onClick={toggleModal} className="flex items-center p-[5px] cursor-pointer"><IconSimpleArrowLeft className="mr-2 flex-[0_1_12px] leading-[130%] transform-[scale(.7)] md:scale-100" /></button></div></div>;
    $[8] = isMobile;
    $[9] = toggleModal;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = photosList && photosList.length;
  const t7 = !!loadMore;
  let t8;
  if ($[11] !== isDesktop || $[12] !== photosList || $[13] !== staticProductData) {
    let t9;
    if ($[15] !== isDesktop || $[16] !== staticProductData) {
      t9 = item => <div className="overflow-hidden mb-8 relative max-[767px]:flex max-[767px]:flex-col-reverse lg:flex lg:flex-wrap" id={`grid-with-sidebar-photo-modal__image-container-${item.photo_id}`}><div className="relative flex justify-center flex-col mb-4 max-[1023px]:pr-[3.333vw] max-[1023px]:pl-[3.333vw] lg:w-1/2 lg:pr-10"><div className="text-base font-bold md:text-lg md:font-bold lg:text-xl lg:block lg:mb-0 lg:font-bold"><CustomerNameWithEmoji className="text-2xl font-bold items-center text-gray flex mb-3">{getShortCustomerName(item.photo_full_name)}</CustomerNameWithEmoji></div>{item.photo_comment && <div className="text-base md:text-lg"><CustomerQuote showQuoteMark={true}>{item.photo_comment}</CustomerQuote></div>}{!!item.products && !!item.products.length && <div className="flex flex-wrap pb-[50px] pt-8 max-[1023px]:grid max-[1023px]:gap-[10px] max-[1023px]:grid-flow-col max-[1023px]:grid-rows-[minmax(100px,1fr)] max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:pb-0 lg:[border-top:1px_solid_#dbdbdb] lg:mt-2 lg:pt-6">{!!staticProductData.length && item.products.map(t10 => {
              const {
                product_id
              } = t10;
              const product_0 = staticProductData.find(productItem => `${productItem?.id}` === `${product_id}`);
              if (!product_0) {
                return null;
              }
              return <div className="w-60"><ProductCardStatic {...product_0} className="mr-4 mb-4" key={product_id} layout="minimal" /></div>;
            }).filter(Boolean)}</div>}</div><div className="mt-4 lg:w-1/2 lg:mt-0 lg:pl-2 first-of-type:max-[1023px]:mt-0"><div className="h-auto [&>div]:w-full [&>div>div]:w-full [&_img]:min-h-full [&_img]:object-cover [&_img]:object-center max-[767px]:relative max-[767px]:mb-4 max-[767px]:text-center"><JBImage sizes={isDesktop ? "50vw" : "100vw"} src={item.image_link} forPage="pdp" trim="auto" /></div></div></div>;
      $[15] = isDesktop;
      $[16] = staticProductData;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t8 = photosList.map(t9);
    $[11] = isDesktop;
    $[12] = photosList;
    $[13] = staticProductData;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[18] !== infiniteScrollThreshold || $[19] !== loadMore || $[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <InfiniteScroll dataLength={t6} next={loadMore} hasMore={t7} scrollThreshold={infiniteScrollThreshold}>{t8}</InfiniteScroll>;
    $[18] = infiniteScrollThreshold;
    $[19] = loadMore;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== loadMore || $[25] !== loadingMore) {
    t10 = !loadingMore && loadMore && <div className="flex flex-col items-center justify-center mt-6 mx-0 mb-[.3rem] max-[767px]:mb-4"><button onClick={loadMore} className="w-[200px] text-center leading-[50px] cursor-pointer uppercase text-[.8em] text-gray border border-solid [border-color:#dbdbdb] rounded-[.1875rem]" type="button">Load more</button></div>;
    $[24] = loadMore;
    $[25] = loadingMore;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <div className="absolute top-0 left-0 w-full h-full pt-6 px-[3.333vw] pb-[9.2rem] mx-0 my-[50px] overflow-auto scroll-smooth max-[1023px]:pr-0 max-[1023px]:pl-0 max-[1023px]:pt-0 max-[1023px]:mt-0">{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t5) {
    t12 = <div className="fixed left-0 w-full h-screen bg-white z-[4002] text-gray lg:top-[var(--visible-promotion-banner-height)]">{t5}{t11}</div>;
    $[30] = t11;
    $[31] = t5;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  const content = t12;
  let t13;
  if ($[33] !== content || $[34] !== isDesktop || $[35] !== toggleModal) {
    t13 = isDesktop ? content : <MobileModal closeIcon="arrow" isOpen={true} onClose={toggleModal} variant="GridWithSidebar">{content}</MobileModal>;
    $[33] = content;
    $[34] = isDesktop;
    $[35] = toggleModal;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  return t13;
};
GridWithSidebarPhotoModal.propTypes = {
  toggleModal: PropTypes.bool,
  photosList: PropTypes.array,
  loadingMore: PropTypes.bool,
  loadMore: PropTypes.bool,
  photo: PropTypes.object
};
export default withBrowserOnly(GridWithSidebarPhotoModal);
function _temp(product) {
  return Number.parseInt(product.product_id, 10);
}
function _temp2(listItem) {
  return listItem.products.map(_temp);
}